/* eslint-disable complexity */
/* eslint-disable react/jsx-key */
import { VisibilityOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import SortableTree from '@nosferatu500/react-sortable-tree';
import { DndContext } from 'react-dnd';

import classes from './treeDataBodyWrapper.module.scss';

const TreeDataBodyWrapper = props => {
  return (
    <div className={classes.treeDataWrapper} style={{ height: '85vh' }}>
      <DndContext.Consumer>
        {({ dragDropManager }) => (
          <SortableTree
            dragDropManager={dragDropManager}
            className={classes.scrolableTreeBody}
            treeData={props.treeData}
            rowDirection="rtl"
            isVirtualized={false}
            canDrag={false}
            canDrop={false}
            onChange={props.changeHandler}
            onMoveNode={({ node, treeIndex, path }) =>
              global.console.debug(
                'node:',
                node,
                'treeIndex:',
                treeIndex,
                'path:',
                path,
              )
            }
            maxDepth={5}
            searchQuery={props.searchString}
            searchFocusOffset={props.searchFocusIndex}
            searchFinishCallback={matches => props.searchFinish(matches)}
            generateNodeProps={rowInfo => ({
              buttons: [
                rowInfo.node?.hasMap ? (
                  <Tooltip placement="right" title="مشاهده">
                    <div>
                      <IconButton
                        color="info"
                        onClick={() => props.showMapHandler(rowInfo)}
                      >
                        <VisibilityOutlined />
                      </IconButton>
                    </div>
                  </Tooltip>
                ) : null,
              ],
            })}
          />
        )}
      </DndContext.Consumer>
    </div>
  );
};

export default TreeDataBodyWrapper;
